/**
 * Image lightbox (tracking/spec §5, staff detail). Wraps the shared Dialog (focus-trap + Esc +
 * focus restore). Shows a public/staff image full-size; keyboard-dismissable.
 */
import { Dialog } from "./Dialog.js";
import type { AttachmentView } from "../api/types.js";

export function Lightbox({
  attachment,
  onClose,
}: {
  attachment: AttachmentView | null;
  onClose: () => void;
}): JSX.Element | null {
  if (!attachment) return null;
  return (
    <Dialog open onClose={onClose} label={attachment.filename} className="td-lightbox">
      <figure className="td-lightbox__fig">
        <img src={attachment.url} alt={attachment.filename} />
        <figcaption className="td-lightbox__cap">{attachment.filename}</figcaption>
      </figure>
    </Dialog>
  );
}
